module.exports = __webpack_public_path__ + "media/images/clients/exit_white-aa73a92643c2ca7b14eda993e05a724b.png";